import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  json: true,
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    //Unauthorized request
    if (
      error.response.status === 401 &&
      // localStorage.getItem("token") &&
      window.location.pathname !== '/'
    ) {
      // localStorage.removeItem("token");
      // localStorage.removeItem("userName");
      // toast.error(error.response.data.message);
      setTimeout(() => {
        window.location.href = '/';
        localStorage.clear();
        sessionStorage.clear();
      }, 1000);
    }
    return Promise.reject(error);
  }
);

const execute = (
  method,
  resource,
  data = null,
  params = null,
  headers = null,
  auth
) =>
  new Promise((resolve, reject) => {
    let options = {
      method,
      url: resource,
      params,
      headers: getHeaders(headers, auth),
    };

    if (resource.includes("contract") || resource.includes("annexure")) {
      options.responseType = "blob";
    }

    if (data !== null) {
      options['data'] = data;
    }

    console.log("🚀 Axios request options:", options);

    client(options)
      .then((req) => {
        // If it's a blob, return the full response to avoid losing type
        if (options.responseType === 'blob') {
          resolve(req); // ✅ returns the full response object
        } else {
          resolve(req.data); // normal case for JSON etc.
        }
      })
      .catch((err) => {
        if (
          err.response.data.status === 500 &&
          (err.response.data.message === 'jwt expired' ||
            err.response.data.message === 'jwt malformed')
        ) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/';
        }
        if (
          err.response &&
          [400, 401, 402, 405, 406, 410, 500, 409, 404].indexOf(
            err.response.status
          ) >= 0
        ) {
          resolve(err.response.data);
        } else {
          reject(err);
        }
      });
  });
const executeNoTokenRequest = (
  method,
  resource,
  data = null,
  params = null,
  headers = null,
  auth
) =>
  new Promise((resolve, reject) => {
    client({
      method,
      url: resource,
      data,
      params,
      headers: headers,
      withCredentials: auth,
    })
      .then((req) => resolve(req.data))
      .catch((err) => {
        if (
          err.response &&
          [400, 401, 402, 403, 405, 406, 410, 500, 409, 404].indexOf(
            err.response.status
          ) >= 0
        ) {
          resolve(err.response.data);
        } else {
          reject(err);
        }
      });
  });

const executeRefreshToken = (
  method,
  resource,
  data = null,
  params = null,
  headers = null,
  auth
) =>
  new Promise((resolve, reject) => {
    client({
      method,
      url: resource,
      data,
      params,
      headers: headers,
      withCredentials: auth,
    })
      .then((req) => resolve(req.data))
      .catch((err) => {
        if (
          err.response &&
          [400, 401, 402, 405, 406, 410, 409, 404].indexOf(
            err.response.status
          ) >= 0
        ) {
          resolve(err.response.data);
        } else {
          reject(err);
        }
      });
  });

const getHeaders = (headers, isAuth = false) => {
  if (isAuth) {
    let token = select();
    return {
      ...headers,
      // Authorization: "Bearer " + token,
      Authorization: token,
    };
  } else {
    return {
      ...headers,
    };
  }
};

const select = (state) => {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

const httpClient = {
  execute,
  executeNoTokenRequest,
  executeRefreshToken,
  client,
};

export default httpClient;
